import React, { FunctionComponent, MouseEventHandler, ReactNode, useEffect } from 'react';
import { Field } from 'react-final-form';
import { FormApi } from 'final-form';
import { isNil } from 'ramda';
import { TextInput } from '~common/components/form/text-input.component';
import { EventFormData } from '~admin/view/components/details/event-form-data';
import { CloseIcon } from '~web/view/components/ui/icon/close-icon.component';
import { Color } from '~common/model/basics';
import { isNilOrEmpty } from '~common/helper/global';

interface ClearButtonProps {
  value: string | null;
  onClick?: MouseEventHandler<SVGElement>;
}

const ClearButton: FunctionComponent<ClearButtonProps> = ({ value, onClick }) => {
  const disabled = isNilOrEmpty(value);

  return (
    <CloseIcon
      color={disabled ? Color.Gray : Color.White}
      width={16}
      height={16}
      onClick={disabled ? null : onClick}
    />
  );
};

interface DatetimeFieldProps {
  name: string;
  label: string;
  form?: FormApi<EventFormData>;
  endAdornment?: ReactNode;
  disabled?: boolean;
  reset?: boolean;
}

export const DatetimeField: React.FunctionComponent<DatetimeFieldProps> = ({
  name,
  label,
  form,
  endAdornment,
  disabled,
  reset,
  ...rest
}) => {
  const showClear = isNil(endAdornment) && !isNil(form);

  const clear = (): void => {
    form.change(name as keyof EventFormData, null);
  };

  useEffect((): void => {
    if (reset) {
      clear();
    }
  }, []);

  return (
    <Field
      label={label}
      name={name}
      render={(renderProps): ReactNode => (
        <TextInput
          type={'datetime-local'}
          fullWidth
          InputProps={{
            endAdornment: showClear ? (
              <ClearButton value={renderProps.input.value} onClick={clear} />
            ) : (
              endAdornment
            ),
          }}
          InputLabelProps={{
            shrink: true,
          }}
          disabled={disabled}
          {...renderProps}
        />
      )}
      {...rest}
    />
  );
};



// WEBPACK FOOTER //
// ./view/components/ui/form/fields/field-datetime.component.tsx